import { Component, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-ph-radio',
  templateUrl: './ph-radio.component.html',
  styleUrls: ['./ph-radio.component.scss'],
})
export class PhRadioComponent {
  @Input() value: string | number;
  @Input() name: string = 'phRadio';
  checked: boolean = false;
  change: EventEmitter<any> = new EventEmitter();

  constructor() {}

  unchecked() {
    this.checked = false;
  }

  update() {
    this.checked = true;
    this.change.emit(this.value);
  }
}
